<script>
    import Icon from '../Icon.svelte';
    import arrowRightIcon from '../../assets/icons/arrow-right.svg?raw';
    import genericIcon from '../../assets/icons/generic.svg?raw';

    const { item, onSelect } = $props();

</script>

<button onclick={() => onSelect(item.id)}>
    <figure>
        {#if item.photo}
            <img src={item.photo} alt="" />
        {:else}
            <Icon data={genericIcon} />
        {/if}
    </figure>

    <span>{item.name}</span>

    <Icon data={arrowRightIcon} />
</button>

<style>

    button {
        display: flex;
        align-items: center;
        gap: 1em;

        width: 100%;
        height: 100%;

        background: var(--box-color);
        color: var(--text-color);
        border-radius: 0.5em;
        border: none;
        padding: 0;
        margin-bottom: 3em;
        overflow: hidden;

        font-size: 1em;
        font-weight: bold;

        cursor: pointer;
    }

    button span {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
    }

    button figure {
        display: grid;
        margin: 0;

        background: rgba(0,0,0,.04);

        align-items: center;
        justify-items: center;

        width: 6em;
        height: 6em;
    }

    button figure > :global(img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    button figure > :global(svg) {
        width: 1.6em;
        height: 1.6em;
    }

</style>
